import React, { useState } from 'react';

export default function SensorStatusIndicator(props) {
    if(props.status === 'Running') {
        return <span class="badge text-bg-success">Online</span>
    }
    return <span class="badge text-bg-danger">Offline</span>;
}